import { $1 } from '../util'
import reqwest from 'reqwest'
import Flash from '../components/Flash'

const NewsletterForm = (() => {
  const manageNewsletterForm = () => {
    const form = $1('.js-newsletter-form')
    if (!form) return

    form.addEventListener('submit', (e) => {
      e.preventDefault()

      const inputValues = {}
      const inputs = form.querySelectorAll('input')
      inputs.forEach((i) => {
        inputValues[i.getAttribute('name')] = i.value
      })

      if (inputValues.email) {
        reqwest({
          url: `${form.getAttribute('action')}&email=${inputValues.email}`,
          method: 'get',
          success: (response) => {
            form.querySelector('input[name="email"]').value = ''
            Flash.success('Thanks!')
          },
          error: (err) => { console.log(err) }
        })
      }
    })
  }

  const init = () => {
    manageNewsletterForm()
  }

  return {
    init,
  }
})()

export default NewsletterForm



// WEBPACK FOOTER //
// app/javascript/scripts/components/NewsletterForm.js